module.exports = "https://web-assets.ifttt.com/packs/media/layout/chevron-down-9fde6a7c.svg";